module.exports = __webpack_public_path__ + "static/content-02-08ed2edcbf778fa34198a6fa0157ea25.jpg";